import { Injectable } from '@angular/core';
import { DataProvider, Widget, DashboardConfigManager, AuthService, LogService, BarChartResponseObject } from "core-dashboard";
import { forkJoin, from } from "rxjs";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable()
export class PmBreakerHealthBarchartProvider implements DataProvider {
    widget: Widget;
    config: any;
    baseUrl: string;
    chartData: any;
    xAxis: string[] = [
        '0% - 10%', 
        '11% - 20%', 
        '21% - 30%', 
        '31% - 40%', 
        '41% - 50%', 
        '51% - 60%', 
        '61% - 70%', 
        '71% - 80%', 
        '81% - 90%', 
        '91% - 100%'];
    valueAPIUrl = '/api/values/';

    constructor(private authService: AuthService,
        private http: HttpClient,
        private logger: LogService,
        dashboardConfig: DashboardConfigManager) {
        this.baseUrl = dashboardConfig.getBaseUrl();
    }

    getData(widget: Widget) {
        this.widget = widget;
        let dpNames: string[] = [];
        try {
            this.config = this.widget.getConfig();
            if (this.config && this.config.dpNames) {
                let commaSaperatedDpNames = this.config.dpNames as string;
                dpNames = commaSaperatedDpNames.split(',');
            }
            if (dpNames.length == 0) {
                this.logger.logWarning("PmBreakerSummaryBarchartProvider", "Invalid request.");
                this.widget.Draw(null);
                return;
            }

            if (this.authService.HasValidSSO() && !this.authService.HasValidToken()) {
                this.authService.LoginWithSSO().subscribe(
                    (response: HttpResponse<any>) => {
                        if (response) {
                            this.RenderChart(dpNames);
                        }
                    }, error => {
                        this.logger.logWarning("PmBreakerSummaryBarchartProvider", "Login error: " + error);
                        this.widget.Draw(null);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.RenderChart(dpNames);
            } else {
                this.logger.logWarning("PmBreakerSummaryBarchartProvider", "Login error.");
                this.widget.Draw(null);
            }

        }
        catch (error) {
            this.logger.logError('PmBreakerSummaryBarchartProvider', "Error while fetching data. Error:" + error);
            this.widget.Draw(null);
        }
    }

    private RenderChart(dpNames: string[]) {
        // this.GetDpValues(dpNames).subscribe((allResponses: HttpResponse<any>[]) => {
        //     try {

        //         console.log(allResponses);
        //         let values: number[] = this.GetValueFromParellelResponse(allResponses)
        //         this.DrawBarChart(values)
        //     }
        //     catch (error) {
        //         this.logger.logError("PmBreakerSummaryBarchartProvider", "Error while processing response : " + error);
        //     }

        // }, (error) => {
            
        //     let errMsg: any = (error && error.message) ? error.message : "Server error";
        //     if (this.logger)
        //         this.logger.logError("PmBreakerSummaryBarchartProvider", "Error while requesting service : " + errMsg);
        //     if (this.widget)
        //         this.widget.Draw(null);
        // });
        this.GetDpValues(dpNames).subscribe({
            next: (allResponses: HttpResponse<any>[]) => {
                try {

                    console.log(allResponses);
                    let values: number[] = this.GetValueFromParellelResponse(allResponses)
                    this.DrawBarChart(values)
                }
                catch (error) {
                    this.logger.logError("PmBreakerSummaryBarchartProvider", "Error while processing response : " + error);
                }

            }, error: (error) => {

                let errMsg: any = (error && error.message) ? error.message : "Server error";
                if (this.logger)
                    this.logger.logError("PmBreakerSummaryBarchartProvider", "Error while requesting service : " + errMsg);
                if (this.widget)
                    this.widget.Draw(null);
            }
        });
    }

    private GetDpValues(dpNames: string[]) {
        var requestUrls: string[] = [];
        dpNames.forEach(dpName => {
            requestUrls.push(this.baseUrl + this.valueAPIUrl + dpName + "?readMaxAge=-1");
        })
        let token: any = this.authService.getToken();
        let headers: HttpHeaders = new HttpHeaders({ "Accept": "application/json", "Access-Control-Allow-Origin": "*", "Authorization": "Bearer " + token });
        var requests = requestUrls.map(url => {
            return this.http.get(url, {
                headers: headers
            })
        });
        return forkJoin(requests);
    }

    private GetValueFromParellelResponse(allResponses: HttpResponse<any>[]) {
        let values: number[] = [];
        allResponses.forEach(response => {
            if (response.status < 200 || response.status >= 300) {
                this.widget.Draw(null);
                throw new Error("Error in response : " + response.statusText);
            }
            if (response && response[0].Value) {
                var dataPoint = response[0].Value;
                if (dataPoint.Value != null && dataPoint.Value != undefined) {
                    let parsedValue = parseFloat(dataPoint.Value);
                    values.push(isFinite(parsedValue) ? parsedValue : 0);
                }
            }
        })
        return values;
    }

    private DrawBarChart(values: number[]) {
        this.SetBarChartData(values)
        let bardata: BarChartResponseObject = {
            DataPointName: "Breaker Summary",
            PropertyName: "",
            xAxisLabel: "Percentage(%)",
            yAxisLabel: "Count",
            ResponseArrayCollection: [this.chartData]
        }
        this.widget.Draw(bardata);
    }

    private SetBarChartData(values: number[]) {
        this.chartData = [];
        if (values && values.length > 0) {
            for (let i = 0; i < this.xAxis.length; i++)
                this.chartData.push({
                    key: this.xAxis[i],
                    value: 0,
                    Unit: "",
                    Resolution: 1
                });

            values.forEach(element => {
                if (element >= 0 && element <= 10) {
                    this.chartData[0].value++;
                }
                else if (this.IsValueInRange(10, 20, element)) {
                    this.chartData[1].value++;
                }
                else if (this.IsValueInRange(20, 30, element)) {
                    this.chartData[2].value++;
                }
                else if (this.IsValueInRange(30, 40, element)) {
                    this.chartData[3].value++;
                }
                else if (this.IsValueInRange(40, 50, element)) {
                    this.chartData[4].value++;
                }
                else if (this.IsValueInRange(50, 60, element)) {
                    this.chartData[5].value++;
                }
                else if (this.IsValueInRange(60, 70, element)) {
                    this.chartData[6].value++;
                }
                else if (this.IsValueInRange(70, 80, element)) {
                    this.chartData[7].value++;
                }
                else if (this.IsValueInRange(80, 90, element)) {
                    this.chartData[8].value++;
                }
                else if (this.IsValueInRange(90, 100, element)) {
                    this.chartData[9].value++;
                }
            });
        }
    }

    private IsValueInRange(min: number, max: number, value: number) {
        return (value > min && value <= max)
    }

    dispose() {

    }

    zoom(zoomFrom: any, zoomTo: any) {

    }

    getReducedCovData(timelinedata: any) {

    }

}